"use client";
export default function LoadingLogo() {
  return (
    <svg
      width="200"
      height="200"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="text-foreground"
    >
      <style>
        {`
          @keyframes scaleUpDown {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.2); }
          }

          @keyframes fadeInOut {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.3; }
          }

          .rect-anim {
            animation: scaleUpDown 1.5s infinite ease-in-out;
            transform-origin: center;
          }

          .path-anim {
            animation: fadeInOut 1.5s infinite ease-in-out;
          }
        `}
      </style>

      <g stroke="currentColor" strokeWidth="3.4" strokeLinecap="round" className="path-anim">
        <line x1="22" y1="4" x2="22" y2="40"></line>
        <line x1="6.4" y1="13" x2="37.6" y2="31"></line>
        <line x1="6.4" y1="31" x2="37.6" y2="13"></line>
      </g>

      <circle cx="22" cy="22" r="4.5" fill="currentColor" className="rect-anim"></circle>
    </svg>
  );
}
